export default __webpack_public_path__ + "static/w-2-177ab3894d47052c146979a6ea533b5a.webp";